export const $mobile = 1024;
export const $smallDesktop = 1200;
export const $mediumDesktop = 1400;

import 'bootstrap';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.easing';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { dm_parallax } from './config/parallax';

gsap.registerPlugin(ScrollTrigger);


import { dm_nav } from './components/nav';


console.log('>> dionysus-init');

jQuery(function ($) {

    "use strict";

    console.log('>> loaded');
    
    dm_parallax();
    dm_nav();

});